export default __webpack_public_path__ + "static/media/Cape of the Imperium.4aeb5479.jpg";